// DEPRECATED: Trial system eliminated
// This component is kept as a stub to prevent import errors
const ConvertTrialUserModal = ({ isOpen, onClose, user, onSuccess }) => {
  // No longer needed - trial system eliminated
  return null;
};

export default ConvertTrialUserModal;
